/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * This code transformed directly via Babel and inlined into index.html
	 * Don't try to import it.
	 */
	(function checkBrowser() {
	  var BAD_BROWSER_URL = 'https://mail.ru/badbrowser';
	  var userAgent = (navigator && navigator.userAgent || '').toLowerCase();
	  var BROWSERS = [{
	    id: 'ie',
	    minVersion: 10,
	    versionRegexp: /(?:msie |trident.+?; rv:)(\d+)/
	  }, {
	    id: 'opera',
	    minVersion: 15,
	    versionRegexp: /(?:^opera.+?version|opr)\/(\d+)/
	  }, {
	    id: 'firefox',
	    minVersion: 29,
	    versionRegexp: /(?:firefox|fxios)\/(\d+)/
	  }, {
	    id: 'safari',
	    minVersion: 8,
	    versionRegexp: /version\/(\d+).+?safari/
	  }];
	  /**
	   * Returns browser version
	   *
	   * @param  {RegExp} regExp
	   * @returns {Number|Boolean}
	   */
	  function getBrowserVersion(regExp) {
	    var match = userAgent.match(regExp);
	    return Boolean(match) && parseInt(match[1]);
	  }
	  /**
	   * Checks one by one all known browsers
	   *
	   * @returns {Boolean}
	   */
	  function checkBrowserSupport() {
	    for (var i = 0; i < BROWSERS.length; i++) {
	      var browser = BROWSERS[i];
	      var version = getBrowserVersion(browser.versionRegexp);
	      if (version && version < browser.minVersion) {
	        return false;
	      }
	    }
	    return true;
	  }
	  /**
	   * Display unsupported browser alert
	   */
	  function showUnsupportedAlert() {
	    // ga('send', 'event', 'Errors', 'Unsupported Browser Detected');
	
	    if (window.top && window.top.location.href) {
	      window.top.location.href = BAD_BROWSER_URL;
	    } else {
	      location.href = BAD_BROWSER_URL;
	    }
	  }
	  var isBrowserSupported = checkBrowserSupport();
	  if (!isBrowserSupported) {
	    showUnsupportedAlert();
	  }
	})();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// check.3e6f244ccf1c6830ff12.js